import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { routesForBottomServiceModeDisplay } from 'utils/routing';

export const useRoutesDisplayBottomService = (): boolean => {
  const location = useLocation();
  const showServiceModeHeader = useMemo(
    () =>
      routesForBottomServiceModeDisplay.some(({ route, exact }) => {
        if (exact) {
          return location.pathname === route;
        }
        return location.pathname.startsWith(route);
      }),
    [location.pathname]
  );
  return showServiceModeHeader;
};
